import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getEmployee } from "../../../lib/getEmployee";
import CredentialCard from "../../components/credencial/credentialCard";
import { AfiliadoServices } from "../../components/credencial/services";

; // Import the getEmployeeByIdService function

// Function to get user details from localStorage
const getUserDetailsFromLocalStorage = () => {
    const userDetails = localStorage.getItem('userDetailsAfiliate');
    return userDetails ? JSON.parse(userDetails) : {};
};

// React component names must start with an uppercase letter
const DashboardAffiliate = () => {
    const [employeeData, setEmployeeData] = useState(null);
    let navigate = useNavigate()
    useEffect(() => {
        const fetchEmployeeData = async () => {
            try {
                const userDetails = getUserDetailsFromLocalStorage();
                const employeeId = userDetails.employee?._id; // Get the employee ID from localStorage
                if (employeeId) {
                    const data = await getEmployee(employeeId); // Fetch employee data using the ID

                    if(!data.firstlog) navigate("/afiliado/edit-afiliado?firstlog=false")
                    setEmployeeData(data);
                }
              
            } catch (error) {
                console.error('Error fetching employee data', error);
            }
        };

        fetchEmployeeData();
    }, []);

    return (
        <>
         <div>
         {employeeData ? (
         <>
            <div className="dashboard-afiliado">
                <CredentialCard employee={employeeData} />
                <AfiliadoServices />
            </div>
            </>
            ) : (
                <p>Cargando datos afiliado...</p>
            )}    
         </div>
        </>
    );
}
export default DashboardAffiliate;
